export default "__VITE_ASSET__IqqzrRlI__"